import React from 'react';
import { InstructionsType } from '../../../types';
import { bonusPuzzleIds } from '../../../analyticsTags';

const Instructions: React.FC<InstructionsType> = ({ onClose, show ,instructionsData}) => {
  const data = {
    title1: instructionsData.Title1,
    img1: instructionsData.Image1,
    alt1: instructionsData.Alt1,
    description1:
      instructionsData.Description1,
    title2: instructionsData.Title2,
    alt2: instructionsData.Alt2,
    img2:instructionsData.Image2,
    description2:instructionsData.Description2,
  };

  return (
    <div className={`bonus-puzzle-instructions-modal${show ? ' show' : ''}`}>
      <div className="bonus-puzzle-instructions">
        <button
    onClick={onClose}
    id={bonusPuzzleIds.bonusPuzzleCloseInstructions}
    className="bonus-puzzle-close"
    aria-label="close"
    title="close intructions"/>
        <div className="bonus-puzzle-instruction">
          <h2 className="title">{data.title1}</h2>
          <img className="img" src={data.img1} alt={data.alt1} />
          <div className="description">{data.description1}</div>
        </div>
        <div className="bonus-puzzle-divider"/>
        <div className="bonus-puzzle-instruction">
          <h2 className="title">{data.title2}</h2>
          <img className="img" src={data.img2} alt={data.alt2} />
          <div className="description">{data.description2}</div>
        </div>
      </div>
    </div>
  );
};

export default Instructions;
